import React, { useEffect, useRef, useContext, useState } from 'react';
import { UserContext } from "../contexts/user";
import Certificate from '../components/Certificate';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import html2canvas from "html2canvas";
import {ShareMenu} from "../components/MyCoursesElements"

const Layout = styled.div`
  max-width: 1000px;
  margin: 2rem auto 0px;
  padding-bottom: 2rem;
  h2{ text-align: center; }
  p { 
    text-align: center;
    a {
      color: yellow;
    }
  }
  .action-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    // gap: 10px;
    flex-wrap: wrap;
    .share-wrapper { width: auto; margin: 0px; display: flex; }
    button{ 
      display: inline-block;
    /* margin-top: 28px; */
      margin: 10px;
      background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
      color: var(--hn-black);
      font-weight: 700;
      padding: 16px 48px;
      font-size: 1.15rem;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-decoration: none;
      font-family: 'Fira Mono', monospace;
    }
  }
`;


// Main My Courses Page Component
const MyCertificate = () => {
  const { user } = useContext(UserContext);
  const [bloggingCourse, setBloggingCourse] = useState();
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Module data with progress

  useEffect(() => {
    (async function () {
      const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses`);
      // const mongoUrl = new URL(`http://localhost:8087`);
      // mongoUrl.searchParams.append("id", "68b959f9eeb27a895ba20f48");
      const firebase = (await import("firebase/app")).default;

      if (!firebase.auth().currentUser) return;

      const token = await firebase.auth().currentUser.getIdToken();

      try {
        const req = await fetch(mongoUrl?.toString(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const response = await req.json();

        // console.log("Service Response", response);
        if (response?.ok === true) {
          // console.log("heree", response)
          if(response?.course?.completed === true){
            setBloggingCourse(response?.course);
            setLoading(false);
          }else {
            navigate('/my-courses');
          }
        }else {
          navigate('/my-courses');
        }
      } catch (e) {
        console.log("something went wrong!", e);
        navigate('/my-courses');
      }
    })()
  }, []);

  const handleDownloadPng = async () => {
    setLoadingDownload(true);
    const domElement = document.getElementById("my-certificate");
    if (domElement) {
      try {
        const canvas = await html2canvas(domElement);
        const pngDataUrl = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = pngDataUrl;
        downloadLink.download = `hackernoon-blogging-course.png`;
        downloadLink.textContent = "Download PNG";

        // Append the link and trigger a click
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
      } catch (e) {
        console.log("something went wrong", e);
      }
      // html2canvas(domElement).then(canvas => {
      //   // Convert canvas to a PNG data URL
      //   const pngDataUrl = canvas.toDataURL("image/png");

      //   // Create a download link
      //   const downloadLink = document.createElement("a");
      //   downloadLink.href = pngDataUrl;
      //   downloadLink.download = `hackernoon-blogging-cource.png`;
      //   downloadLink.textContent = "Download PNG";

      //   // Append the link and trigger a click
      //   document.body.appendChild(downloadLink);
      //   downloadLink.click();
      //   document.body.removeChild(downloadLink);
      //   // domElement.style.boxShadow = "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,rgb(209, 213, 219) 0px 0px 0px 1px inset";
      // });
    }
    setLoadingDownload(false);
  };

  if(loading) { 
    return (
      <div className="loading-component">
        <lottie-player 
          src="/loader_lottie.json" 
          background="transparent" 
          speed="1" 
          style={{width: '300px', height: '300px'}}
          loop 
          autoplay>
        </lottie-player>
      </div>
    )
  }

  // console.log(loadingDownload)


  return (
    <Layout>
      <h2> 🥳 Hard Work, Always Pays Off! Congrats @{user?.handle || "hacker"} 🎉</h2>
      <p>
        If the name on the certificate is incorrect, please update it 
        {" "}
        <a href="https://app.hackernoon.com/profile" target='_blank'>here</a>.
      </p>
      <div>
        <div id="my-certificate" style={{display: "flex", flexDirection: "column"}}>
          <Certificate name={user?.displayName || user?.name} completedAt={bloggingCourse?.completedAt || null} />
        </div>
        <div className='action-btn'>
          <ShareMenu completed={true}  />
          <button onClick={() => handleDownloadPng()} >
            {loadingDownload ? (<img src="/loading.gif" width={20} alt="loader" />) : "Download"}
          </button>
          <button onClick={() => window.open("https://hackernoon-course-review.paperform.co/", "_blank")} >
            Review Course
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default MyCertificate;
